import { type DistributiveOmit } from './misc'

export const IS_ANALYTICS_ENABLED = process.env.BUILD_TYPE === 'prod'

type AnalyticsEventBaseType = {
  action: string
  category: string
  label?: string
  nonInteraction?: boolean
}

export type AnalyticsEventType = AnalyticsEventBaseType &
  DistributiveOmit<Record<string, boolean | number | string | undefined>, keyof AnalyticsEventBaseType>
